
import { mapActions } from 'vuex';
import ScheduleBlock from '~/views/schedule-block';
import seo from '~/mixins/seo';

export default {
  name: 'schedule',
  layout: 'index',
  components: {
    ScheduleBlock,
  },
  mixins: [seo],
  data () {
    return {
      schedule: [],
      scheduleLoading: true,
    };
  },
  mounted() {
    this.loadSchedule();
  },
  methods: {
    ...mapActions(['getSchedule']),
    loadSchedule(type = 'departure') {
      this.scheduleLoading = true;
      this.getSchedule({type}).then(res => {
        this.schedule = res;
        this.scheduleLoading = false;
      });
    },
  },
};
